import Timeago from "@pathwright/ui/src/components/timeago/Timeago"
import React from "react"

class SubmissionFileSubmitted extends React.Component {
  static displayName = "SubmissionFileSubmitted"

  render() {
    const { step, completion } = this.props.stepStore.state
    if (completion.submission_file_url) {
      return (
        <div className="SubmissionCard">
          <div className="Submission__submitted">
            {`\
You submitted: `}
            <a href={completion.submission_file_url}>
              {completion.submission_file_name}
            </a>
            <p className="Submission__submitted-when">
              {`\
Submitted `}
              <Timeago date={completion.completion_date} />
            </p>
          </div>
        </div>
      )
    } else {
      return <span>No file submitted.</span>
    }
  }
}

export default SubmissionFileSubmitted
